import { useState, useMemo } from "react";
import { deleteMember } from "../../../../api/DeleteMember";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsis } from "@fortawesome/free-solid-svg-icons";
import { DASHBOARD_MODALS } from "../../Dashboard";
import DataTable from "../../../shared/DataTable/DataTable";

export const MemberTable = ({ data, setModal, localUserData }) => {
  const [memberList, setMemberList] = useState(data);
  const [selectedIds, setSelectedIds] = useState([]);
  const [openMenuId, setOpenMenuId] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(-1);

  const memberDeleteButtonCallback = (memberId) => {
    try {
      deleteMember(memberId);
      setMemberList((prev) => prev.filter((m) => m.id !== memberId));
      setConfirmDelete(-1);
      setOpenMenuId(null);
    } catch (error) {
      console.error("Error deleting member:", error);
    }
  };

  const columns = useMemo(() => [
    {
      id: "select",
      header: () => null,
      cell: ({ row }) => (
        <input
          type="checkbox"
          checked={selectedIds.includes(row.original.id)}
          onChange={() =>
            setSelectedIds((prev) =>
              prev.includes(row.original.id)
                ? prev.filter((x) => x !== row.original.id)
                : [...prev, row.original.id]
            )
          }
          className="w-4 h-4 rounded border-gray-300 accent-blue cursor-pointer"
        />
      ),
      enableSorting: false,
      enableGlobalFilter: false,
      size: 40,
    },
    {
      accessorKey: "first_name",
      header: "First Name",
    },
    {
      accessorKey: "last_name",
      header: "Last Name",
    },
    {
      accessorKey: "np_access_level",
      header: "Role",
      cell: ({ getValue }) => {
        const v = getValue();
        return v === "edit" ? "Member" : v === "admin" ? "Admin" : v;
      },
    },
    {
      id: "actions",
      header: () => null,
      cell: ({ row }) => {
        const member = row.original;
        return (
          <div className="text-center relative">
            {confirmDelete === member.id ? (
              <div className="flex gap-1 justify-center">
                <button
                  onClick={() => memberDeleteButtonCallback(member.id)}
                  className="text-xs text-white bg-red-500 px-2 py-1 rounded-full hover:bg-red-600"
                >
                  Confirm
                </button>
                <button
                  onClick={() => setConfirmDelete(-1)}
                  className="text-xs text-gray-600 border border-gray-300 px-2 py-1 rounded-full hover:bg-gray-100"
                >
                  Cancel
                </button>
              </div>
            ) : (
              <>
                <button
                  onClick={() =>
                    setOpenMenuId(openMenuId === member.id ? null : member.id)
                  }
                  className="text-gray-500 hover:text-gray-800 bg-transparent border-none outline-none"
                >
                  <FontAwesomeIcon icon={faEllipsis} />
                </button>
                {openMenuId === member.id &&
                  localUserData?.user_type === "nonprofit_admin" &&
                  localUserData?.id !== member.id && (
                    <div className="absolute right-0 top-8 z-10 bg-white border border-gray-200 rounded-xl shadow-lg py-1 min-w-[120px]">
                      <button
                        onClick={() => {
                          setConfirmDelete(member.id);
                          setOpenMenuId(null);
                        }}
                        className="w-full text-left px-4 py-2 text-sm text-red-500 hover:bg-gray-50"
                      >
                        Delete
                      </button>
                    </div>
                  )}
              </>
            )}
          </div>
        );
      },
      enableSorting: false,
      enableGlobalFilter: false,
      size: 40,
    },
  ], [selectedIds, openMenuId, confirmDelete, localUserData]);

  return (
    <DataTable
      columns={columns}
      data={memberList}
      filterPlaceholder="Search by name"
      totalLabel="Total Team Members"
      emptyMessage="No members found."
    />
  );
};
